<template>
  <div class="Background">
    <DashboardForm />
  </div>
</template>

<script>
import DashboardForm from '@/components/dashboard/DashboardForm.vue';

export default {
  components: {
    DashboardForm
  }

}
</script>

<style lang="scss" scoped></style>